var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { styles } from "../styles";
import { unsafeSVG } from "lit/directives/unsafe-svg.js";
import { icons } from "../util/icons";
/**
 * The bender-search element.
 */
let Search = class Search extends LitElement {
    render() {
        return html `
      <a
        class="header-btn"
        href="https://www.bing.com/work"
      >
        ${unsafeSVG(icons.loupe)}
      </a>
    `;
    }
};
Search.styles = styles;
Search = __decorate([
    customElement("bender-search")
], Search);
export { Search };
//# sourceMappingURL=search.js.map